SJ.Tournament =
class {
  constructor(name, mapsArray, seriesCount){
    this.name = name;

    this.mapsArray = mapsArray;

    this.lastMap = false;
    this.endOfSeries = false;

    this.defaultSeriesCount = seriesCount;
    this.curMapSeriesCount = seriesCount;

    SJ.pauseMenu.restartBtn.disabled = true;

    console.log('-----STARTING TOURNAMENT-----')
    console.log(`Maps: ${this.mapsArray}`);
    console.log(`Series: ${this.defaultSeriesCount}`);
    console.log('');

    this.runNextTournamentMap();
  }

  continueTournament(){
    if(this.endOfSeries)
      this.runNextTournamentMap();
    else
      this.nextJump();
  }

  runNextTournamentMap() {

    if(this.mapsArray.length > 0){

      let mapToRun = this.mapsArray[0];
      mapToRun = mapToRun.replace(' ', '');

      this.mapsArray.shift();

      if(this.mapsArray.length < 1)this.lastMap = true;

      console.log(`Loading next tournament map: ${mapToRun}`);

      this.setDefaultBeforeNewMap();
      this.nextJump();

      SJ._state = SJ._STATE.WAITING;
      SJ.main = null;
      SJ._startGame(mapToRun, mapToRun);
    }
  }

  nextJump() {
    this.curMapSeriesCount -= 1;
    if(this.curMapSeriesCount < 1)this.endOfSeries = true;
    SJ.restartGame();
  }

  endTournament(){
    SJ._endTournament();
    SJ.backToMenu();
  }

  setDefaultBeforeNewMap() {
    this.curMapSeriesCount = this.defaultSeriesCount;
    this.endOfSeries = false;
  }
}